export default "__VITE_ASSET__BhK19OTc__"